module.exports = __webpack_public_path__ + "img/telephone.07cde98a.svg";